import React, { FC } from 'react';
import TasksLink from '@/components/TasksLink';

interface Props {
  propertyId: string;
}

const AutomationMovedNotice : FC<Props> = ({ propertyId }) => {
	return (
    <p style={{ marginTop: '20px' }}>
      We have moved the tasks configuration to the new tasks configuration page.
      <br />
      <br />
      Please select the property and click on <TasksLink propertyId={propertyId}>this link</TasksLink> to access the new page.
    </p>
	);
};

export default AutomationMovedNotice;
